<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

<ng-template #typ00>
  <span [capHistinfo]="histInfo">
    @if (item.alt) {
      {{ item | formatBeleg: false }}
    } @else {
      <ng-template [ngTemplateOutlet]="commonOhneDatum"></ng-template>
    }
    <ng-template [ngTemplateOutlet]="dokulink"></ng-template>
  </span>
</ng-template>

<ng-template #typ01 let-item>
  <span [capHistinfo]="histInfo">
    @if (isEigentuemer && showBeleg) {
      {{ item | formatBeleg }}
    } @else {
      <ng-template [ngTemplateOutlet]="onlyDatum"></ng-template>
    }
    <ng-template [ngTemplateOutlet]="dokulink"></ng-template>
  </span>
</ng-template>

<ng-template #typ02 let-item>
  <ng-template [ngTemplateOutlet]="onlyDatum"></ng-template>
</ng-template>

<ng-template #typ03 let-item>
  <span [capHistinfo]="histInfo">
    @if (item.alt || isEigentuemer) {
      {{ item | formatBeleg }}
    } @else {
      @if (showBeleg) {
        {{ item | formatBeleg }}
      } @else {
        <ng-template [ngTemplateOutlet]="onlyDatum"></ng-template>
      }
    }
    <ng-template [ngTemplateOutlet]="dokulink"></ng-template> </span
></ng-template>

<ng-template #commonOhneDatum> {{ item | formatBeleg: false }}</ng-template>

<ng-template #onlyDatum>
  {{ item.datum | datum }}
</ng-template>

<ng-template #dokulink>
  @if (isDokuLinkGeschaeftConfigured) {
    <cap-dokulink [item]="dokulinkItem"></cap-dokulink>
  }
</ng-template>
